import { PAGES } from "../../constants"

export const NavItems = [
  { label: "Home", to: "/", pageId: PAGES.HOME },
  { label: "About Us", to: "/about", pageId: PAGES.ABOUT_US },
  { label: "Careers", to: "/careers", pageId: PAGES.CAREERS },
  { label: "Contact Us", to: "/contactus", pageId: PAGES.CONTACT_US },
]
